import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { wineNaming } from "@/js/wine/wine.js";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { orderStatus, listTerms, orderTypes } from "@/js/lists.ts";
import { hasRole } from "@/js/http/auth.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object,
    isShown: false,
    dialog: Boolean,
    canManageSupplierPrices: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default: {}
    },
    importersAvailable: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      drawer: false,
      form: {
        isPreventInvoice: false,
        terms: null,
        valid: false
      },
      isSendNotificationMails: true,
      isSendNotificationMailsToImporter: false,
      bypassWithoutSupplierPrice: false,
      itemsMissingSupplierPrices: [],
      missingSupplierPricesHeaders: [{
        text: "SKU",
        value: "sku"
      }, {
        text: "Product",
        value: "name"
      }, {
        text: "",
        value: "actions",
        sortable: false,
        align: "end"
      }],
      steps: [],
      defaultSteps: [],
      currentStep: 1,
      rules: formRules,
      isValidatingOrder: false,
      isStatelessDrawer: true,
      isChangingTerms: false,
      errorOccurred: false,
      interval: null,
      isEditingImporter: false,
      importerSelectorSelected: null,
      changeOrderImporterCancellationToken: null,
      listTerms: listTerms,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    hasImporter: function hasImporter() {
      return this.importersAvailable.length > 0;
    },
    canEditImporter: function canEditImporter() {
      var _this$importersAvaila,
        _this2 = this;
      return ((_this$importersAvaila = this.importersAvailable.filter(function (x) {
        var _this2$order$importer;
        return x.id != ((_this2$order$importer = _this2.order.importer) === null || _this2$order$importer === void 0 ? void 0 : _this2$order$importer.id);
      })) === null || _this$importersAvaila === void 0 ? void 0 : _this$importersAvaila.length) > 0 && !this.order.isImporterInvoiced;
    },
    importerSelectedHasMail: function importerSelectedHasMail() {
      return this.hasImporter && !String.isNullOrEmpty(this.importerSelectorSelected.mailContact);
    },
    canBypassItemsWithoutSupplierPrices: function canBypassItemsWithoutSupplierPrices() {
      return hasRole(process.env.VUE_APP_ROLES_BYPASS_ORDER_VALIDATE_WITHOUT_SUPPLIER_PRICES);
    },
    isInvalidForm: function isInvalidForm() {
      var _this$order$importer;
      if (!this.form.terms) return true;
      if (this.hasImporter && !((_this$order$importer = this.order.importer) !== null && _this$order$importer !== void 0 && _this$order$importer.id)) return true;
      if (this.itemsMissingSupplierPrices.length > 0 && this.itemsMissingSupplierPrices.some(function (x) {
        var _ref, _x$supplierPricesList;
        return ((_ref = (_x$supplierPricesList = x.supplierPricesList) !== null && _x$supplierPricesList !== void 0 ? _x$supplierPricesList : x.suppliersPricesList) === null || _ref === void 0 ? void 0 : _ref.length) === 0;
      }) && !this.bypassWithoutSupplierPrice) return true;
      return false;
    },
    termsLabel: function termsLabel() {
      var _listTerms$find,
        _this3 = this;
      return (_listTerms$find = listTerms.find(function (x) {
        return x.id === _this3.form.terms;
      })) === null || _listTerms$find === void 0 ? void 0 : _listTerms$find.name;
    },
    isContainerOrderOrLinkedToContainerOrder: function isContainerOrderOrLinkedToContainerOrder() {
      var _this$order$parentCon;
      return this.order.type === orderTypes.CONTAINER || ((_this$order$parentCon = this.order.parentContainerOrder) === null || _this$order$parentCon === void 0 ? void 0 : _this$order$parentCon.id_order) > 0;
    },
    itemsProvenanceFromOrder: function itemsProvenanceFromOrder() {
      return this.order.items.filter(function (x) {
        return x.item_provenances.some(function (p) {
          var _p$stockPart;
          return ((_p$stockPart = p.stockPart) === null || _p$stockPart === void 0 || (_p$stockPart = _p$stockPart.fromOrderData) === null || _p$stockPart === void 0 ? void 0 : _p$stockPart.id) > 0;
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          item_provenances: item.item_provenances.filter(function (provenance) {
            var _provenance$stockPart;
            return ((_provenance$stockPart = provenance.stockPart) === null || _provenance$stockPart === void 0 || (_provenance$stockPart = _provenance$stockPart.fromOrderData) === null || _provenance$stockPart === void 0 ? void 0 : _provenance$stockPart.id) > 0;
          })
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          quantity: item.item_provenances.reduce(function (acc, x) {
            return acc + x.quantity;
          }, 0)
        });
      });
    },
    itemsProvenanceNotFromOrder: function itemsProvenanceNotFromOrder() {
      return this.order.items.filter(function (x) {
        return x.item_provenances.some(function (p) {
          var _p$stockPart2;
          return !((_p$stockPart2 = p.stockPart) !== null && _p$stockPart2 !== void 0 && (_p$stockPart2 = _p$stockPart2.fromOrderData) !== null && _p$stockPart2 !== void 0 && _p$stockPart2.id) > 0;
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          item_provenances: item.item_provenances.filter(function (provenance) {
            var _provenance$stockPart2;
            return !((_provenance$stockPart2 = provenance.stockPart) !== null && _provenance$stockPart2 !== void 0 && (_provenance$stockPart2 = _provenance$stockPart2.fromOrderData) !== null && _provenance$stockPart2 !== void 0 && _provenance$stockPart2.id) > 0;
          })
        });
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          quantity: item.item_provenances.reduce(function (acc, x) {
            return acc + x.quantity;
          }, 0)
        });
      });
    },
    hasWarningItemsProvenanceAboutInvoice: function hasWarningItemsProvenanceAboutInvoice() {
      var _this$itemsProvenance, _this$itemsProvenance2;
      return !this.isContainerOrderOrLinkedToContainerOrder && (this.form.isPreventInvoice && ((_this$itemsProvenance = this.itemsProvenanceNotFromOrder) === null || _this$itemsProvenance === void 0 ? void 0 : _this$itemsProvenance.length) > 0 || !this.form.isPreventInvoice && ((_this$itemsProvenance2 = this.itemsProvenanceFromOrder) === null || _this$itemsProvenance2 === void 0 ? void 0 : _this$itemsProvenance2.length) > 0);
    }
  },
  watch: {
    isShown: function isShown(visible) {
      this.drawer = visible;
      this.closureAttempt = 0;
      if (this.hasImporter) {
        this.isEditingImporter = false;
      }
      if (visible) {
        this.form.terms = this.order.buyer_term;
        this.form.isPreventInvoice = !!this.order.isPreventInvoice;
        if (!this.defaultSteps.length) {
          this.defaultSteps = _toConsumableArray(this.steps.map(function (x) {
            return _objectSpread({}, x);
          }));
        }
        this.initStep();
      }
    }
  },
  updated: function updated() {
    this.closureAttempt++;
  },
  methods: {
    clickOutsideDrawer: function clickOutsideDrawer() {
      this.drawer = this.isStatelessDrawer && this.isShown;
    },
    toggleTerms: function toggleTerms() {
      this.isChangingTerms = !this.isChangingTerms;
    },
    close: function close() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this4.$refs.confirm.open("Cancel", "Are you sure you want to cancel the approvement ?");
            case 2:
              isConfirmed = _context.sent;
              if (isConfirmed) {
                _this4.currentStep = 1;
                _this4.steps = _toConsumableArray(_this4.defaultSteps.map(function (x) {
                  return _objectSpread({}, x);
                }));
                _this4.isStatelessDrawer = false;
                _this4.drawer = false;
                _this4.$emit("close", true);
                _this4.isStatelessDrawer = true;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    validate: function validate() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var isConfirmed, _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this5.$refs.confirm.open("Order validation", "Are you sure you want to validate the order?");
            case 2:
              isConfirmed = _context2.sent;
              if (!isConfirmed) {
                _context2.next = 9;
                break;
              }
              _this = _this5;
              _this5.isValidatingOrder = true;
              _context2.next = 8;
              return _this5.putOrder(_this5.order, {
                send_mails: _this5.isSendNotificationMails,
                paymentTerms: _this5.form.terms,
                isPreventInvoice: _this5.form.isPreventInvoice,
                notifyImporter: _this5.isSendNotificationMailsToImporter,
                bypassWithoutSupplierPrice: _this5.bypassWithoutSupplierPrice
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to validate the order", true);
                handleErrorData(_this, errorData);
                _this.isValidatingOrder = false;
                throw e;
              });
            case 8:
              _this5.$emit("validate", true, function () {
                _this5.$emit("close", true);
                _this5.isValidatingOrder = false;
                _this5.$toasted.show("Order validated.", {
                  type: "success"
                });
              });
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    putOrder: function putOrder(order, body) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return request("/v1/order/" + order.id_order + "/state/" + orderStatus.find(function (os) {
                return os.id === "VALIDATED";
              }).status, "put", body, true, "api");
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    initStep: function initStep() {
      var _this$order$user$comp,
        _this6 = this;
      this.currentStep = 1;
      var fullName = this.order.user.user_group == "HORECA" || this.order.user.user_group == "WHOLESALER" || this.order.user.isHolding ? (_this$order$user$comp = this.order.user.company_name) !== null && _this$order$user$comp !== void 0 ? _this$order$user$comp : "".concat(this.order.user.nickname, " ").concat(this.order.user.name) : "".concat(this.order.user.nickname, " ").concat(this.order.user.name);
      var stepCount = 1;
      this.steps = [{
        id: stepCount++,
        key: "terms",
        title: "Payment terms desired by ".concat(fullName),
        inf: "Please check the desired payment terms and rectify it if needed."
      }];
      var directWineryItems = this.order.items.filter(function (x) {
        return x.isDirectWinery;
      });
      this.itemsMissingSupplierPrices = directWineryItems === null || directWineryItems === void 0 ? void 0 : directWineryItems.filter(function (x) {
        var _ref2, _x$suppliersPricesLis;
        var supplierPricesList = (_ref2 = (_x$suppliersPricesLis = x.suppliersPricesList) !== null && _x$suppliersPricesLis !== void 0 ? _x$suppliersPricesLis : x.supplierPricesList) !== null && _ref2 !== void 0 ? _ref2 : [];
        return supplierPricesList.length === 0;
      });
      if (this.itemsMissingSupplierPrices.length > 0) {
        this.steps.push({
          id: stepCount++,
          key: "supplier_prices",
          title: "Missing supplier prices",
          inf: "Please add supplier prices for missing items."
        });
      }
      if (this.hasImporter) {
        var _this$importersAvaila2;
        this.importerSelectorSelected = (_this$importersAvaila2 = this.importersAvailable.find(function (x) {
          var _this6$order$importer;
          return x.id == ((_this6$order$importer = _this6.order.importer) === null || _this6$order$importer === void 0 ? void 0 : _this6$order$importer.id);
        })) !== null && _this$importersAvaila2 !== void 0 ? _this$importersAvaila2 : this.importersAvailable[0];
        this.isSendNotificationMailsToImporter = !String.isNullOrEmpty(this.importerSelectorSelected.mailContact) && this.importerSelectorSelected.isDefaultReceiveEmails && this.order.user.user_group === "USER";
        this.steps.push({
          id: stepCount++,
          key: "importer",
          title: "Importer",
          inf: "Please verify or select the right importer."
        });
      }
      this.steps.push({
        id: stepCount++,
        key: "prevent_invoice",
        title: "Invoice / Order confirmation"
      });
      this.steps.push({
        id: stepCount,
        key: "synthesis",
        title: "Synthesis"
      });
    },
    confirmStep: function confirmStep() {
      this.currentStep++;
    },
    startEditImporter: function startEditImporter() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this7.isEditingImporter = true;
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    saveChangeImporter: function saveChangeImporter() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this8$order$importer;
        var _this8$changeOrderImp, _this, data;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(((_this8$order$importer = _this8.order.importer) === null || _this8$order$importer === void 0 ? void 0 : _this8$order$importer.id) !== _this8.importerSelectorSelected.id)) {
                _context5.next = 9;
                break;
              }
              (_this8$changeOrderImp = _this8.changeOrderImporterCancellationToken) === null || _this8$changeOrderImp === void 0 || _this8$changeOrderImp.cancel();
              _this8.changeOrderImporterCancellationToken = axios.CancelToken.source();
              _this = _this8;
              data = {
                importerId: _this8.importerSelectorSelected.id
              };
              _context5.next = 7;
              return request("/v1/orders/" + +_this8.order.id_order + "/importer", "put", data, true, "api", null, _this8.changeOrderImporterCancellationToken).then(function (_) {
                _this.order.importer = _this.importersAvailable.find(function (x) {
                  return x.id === _this.importerSelectorSelected.id;
                });
                _this.isEditingImporter = false;
                _this.isSendNotificationMailsToImporter = !String.isNullOrEmpty(_this8.importerSelectorSelected.mailContact) && _this8.importerSelectorSelected.isDefaultReceiveEmails && _this8.order.user.user_group === "USER";
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to change importer");
                  handleErrorData(_this, errorData);
                  _this.isEditingImporter = false;
                }
              });
            case 7:
              _context5.next = 10;
              break;
            case 9:
              _this8.isEditingImporter = false;
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    wineNaming: wineNaming
  }
};